<div class="landscape">
  <div class="content">
    <img src="assets/images/group.svg" alt="" class="landscape-img">

    <h1 class="landscape-title">gira tu dispositivo</h1>

    <p class="landscape-text">para seguir con tu solicitud</p>
  </div>
</div>

<voxel-it-selfie
  id="frontal-photo-selfie"
  [routeToNavigate]="previousRoute"
  [repeatPictureLabel]="'Tomar otra'"
  [compressedResolutionHeight]="compressedResolutionHeight"
  [maxImageLenght]="maxImageLenght"
  [errorRoute]="errorRoute"
  [noPermissionRoute]="noPermissionRoute"
  headerTitle="Selfie de frente"
  headerSubTitle="Tomá la foto sin lentes ni gorro"
  faceCam="true"
  [events]="eventsSubject.asObservable()"
  (sendImage)="sendImageEvent($event)"
  [synchronousSendImage]="false"
  analyticsPage = "ReviewSelfieFrente"
  transactionStep = "17">
</voxel-it-selfie>
<facebook-pixel></facebook-pixel>
